window.CoreEcho = null;

window._ = require('lodash');

window.$ = window.jQuery = require('jquery');

window.select2 = require('select2');
window.Tether = require('tether');

import Popper from 'popper.js';

window.Popper = Popper;
window.laravel_route = require('../../../app/Shared/Resources/Assets/js/helpers/routes.js');

window.grid_breakpoints = {
    xs: {min: 0, max: 575},
    sm: {min: 576, max: 767},
    md: {min: 768, max: 991},
    lg: {min: 992, max: 1200},
    xl: {min: 1200, max: 4800},
};

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
// require('vue2-animate/dist/vue2-animate.min.css');
require('./config/vueComponents');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
};

/**
 * Include EchoServer Stuff
 */
require('./config/echoServer');

/**
 * Material Design plugins
 */
require('./config/materialDesign');
// require('../vendor/MDB Pro 4.4.3/js/mdb')
require('hideshowpassword');

window.Dropzone = require('dropzone');
window.password = require('password-strength-meter');


require('./bootstrap');
require('./components/navigation/sideNavAccordion');

require('./pages/tickets--crud');

window.classesAndIds = require('./helpers/classesAndIds');

require('./operations/client-switcher');

window.moment = require('moment');

// window.Isotope = require('isotope-layout');

window.Masonry = require('masonry-layout');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js